<template>
  <base-modal>
    <z-form ref="form">
      <z-form-group class="row">
        <div class="col-4">
          {{ $t('voice.trunk.field.my_ip') }}
        </div>
        <div class="col-8">
          <z-form-input :rules="{ required: true, ip: true }">
            <i-input v-model="form.ip" @input="clear" />
          </z-form-input>
          <p v-if="status_is_created" class="form-input__error form-input__error--absolute">
            {{ $t('voice.trunk.modal.ip_exist') }}
          </p>
        </div>
      </z-form-group>

      <z-form-group class="row">
        <div class="col-4">
          {{ $t('voice.trunk.field.prefix') }}
        </div>
        <div class="col-8">
          <z-form-input :rules="{ required: false }">
            <i-input v-model="form.prefix" />
          </z-form-input>
        </div>
      </z-form-group>
    </z-form>

    <i-button
      slot="footer-ok"
      type="success"
      size="large"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import { TrunkService } from '@voice/services/TrunkService';

  export default {
    components: {
      BaseModal
    },

    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      form: {},
      is_button_loading: false,
      status_is_created: false,
      status_exists: false
    }),

    created() {
      TrunkService.getSelect().then((data) => this.items = data)
    },

    methods: {
      compare_ip() {
        this.items.forEach(item => {
          if(this.ip_disabled) return;
          if (this.form.ip === item.client) {
            this.status_is_created = true;
            this.status_exists = true;
            return;
          }
        });
      },
      clear() {
        this.status_is_created = false;
        this.status_exists = false;
      },
      save: function() {
        this.compare_ip();
        if (this.status_exists === true) return false;
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            this.is_button_loading = true;

            TrunkService.addIps(this.item.id, this.form)
              .then(res => {
                this.$emit('success', res)
              })
              .catch(e => {
                this.$noty.server_error(e);
                this.$emit('fail', e);
              })
              .finally(() => (this.is_button_loading = false));
          }
        });
      }
    }
  };
</script>
